module.exports = "/assets/QA_V2-6e10c04742b7ba9b7e9e572517433a10.jpg";